module.exports = __webpack_public_path__ + "static/21-ce096b12027c5bd1d82da2deae714e15.jpg";